import { render, staticRenderFns } from "./SurgeryInfo.vue?vue&type=template&id=511c5fad&scoped=true&"
import script from "./SurgeryInfo.vue?vue&type=script&lang=js&"
export * from "./SurgeryInfo.vue?vue&type=script&lang=js&"
import style0 from "./SurgeryInfo.vue?vue&type=style&index=0&id=511c5fad&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511c5fad",
  null
  
)

export default component.exports